import { render, staticRenderFns } from "./BaseDivider.vue?vue&type=template&id=469b4f8c&functional=true&"
import script from "./BaseDivider.vue?vue&type=script&lang=ts&"
export * from "./BaseDivider.vue?vue&type=script&lang=ts&"
import style0 from "./BaseDivider.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports